import React from 'react';

import {  Row, Col, Card, Tabs, Tab } from "react-bootstrap";

const AdminParams = () => {
    return ( 
        <>
            <Row>
                <Col>
                    <h1 className="h3 mb-2 text-gray-800">Aministración de Parametría</h1>
                    <hr />
                </Col>
            </Row>

            <Tabs defaultActiveKey="profile" id="uncontrolled-tab-example">
                        <Tab eventKey="home" title="Home">
                            <Card>
                                
                                <Card.Body>
                                    <Card.Title>1</Card.Title>
                                    <hr/>
                                    
                                
                                    
                                </Card.Body>
                            </Card>
                        </Tab>
                        <Tab eventKey="profile" title="Profile">
                            <Card>
                               
                                <Card.Body>
                                    <Card.Title>2</Card.Title>
                                    <hr/>
                                
                                    
                                </Card.Body>
                            </Card>
                        </Tab>
                        <Tab eventKey="contact" title="Contact" disabled>
                            <Card>
                               
                                <Card.Body>
                                    <Card.Title>3</Card.Title>
                                    <hr/>
                                
                                    
                                </Card.Body>
                            </Card>
                        </Tab>
                    </Tabs>
            
           
        </>
     );
}
 
export default AdminParams;